export default "__VITE_ASSET__BLuQTQBk__"